import React from 'react';
import { SavedJobs } from './Applications/SavedJobs';
import { UserDashboardLayout } from '../../layouts/UserDashboardLayout';

export function JobSavedJobs() {
	return (
		<UserDashboardLayout>
			<SavedJobs />
		</UserDashboardLayout>
	)
}